import { LogOut } from 'lucide-react';
import { useAuthStore } from '../../stores/auth';
import { useTranslation } from 'react-i18next';

export function UserMenu() {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);

  if (!user) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <div className="min-w-0 flex-1">
        <p className="truncate text-meta text-content">{user.name ?? user.email}</p>
        {user.name ? <p className="truncate text-meta text-content-muted">{user.email}</p> : null}
      </div>
      <button
        type="button"
        onClick={() => void logout()}
        title={t('auth.signOut')}
        aria-label={t('auth.signOut')}
        className="shrink-0 rounded-control p-1.5 text-content-muted transition-colors duration-fast hover:bg-surface-hover hover:text-content"
      >
        <LogOut className="h-4 w-4" strokeWidth={1.75} />
      </button>
    </div>
  );
}
